var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Row, Col } from "react-bootstrap";
import React, { Component } from "react";
import { isString } from "lodash";
import Form from "@irati/ui/src/Form";
import Select from "@irati/ui/src/FormItem/Select";
import { Firstname, Lastname, Email, Locale, ExternalID, Office } from "@irati-web/fields/user";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import Loading from "@irati/ui/src/Loading";
import { H2 } from "@irati/ui/src/Typography";
import { IconButton } from "@irati/ui/src/Button";
import mfaService from "@irati/auth/services/mfa";
import YouNeedToMfa from "@irati-web/mfa/components/Error/YouNeedToMfa";
import adminTracking from "@irati-tracking/admin";
import authentication from "@irati/auth";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import usersService from "@irati/identity/services/users";
import { hangPromise } from "@irati/utils/promise";
import hasMultipleOffices from "@irati/identity/utils/tenant/hasMultipleOffices";
import teamService from "@irati/identity/services/teams";
import { enumToArray } from "@irati/utils/enumToArray";
import SuccessWithBackLink from "../../../components/SuccessWithBackLink";
var UserRole;
(function (UserRole) {
    UserRole["user"] = "admin.containers.addOnePerson.fields.role.label.user";
    UserRole["admin"] = "admin.containers.addOnePerson.fields.role.label.admin";
})(UserRole || (UserRole = {}));
var RoleOptions = function (formatMessage) {
    return enumToArray(UserRole).map(function (role) {
        return { label: formatMessage({ id: role }), value: role };
    });
};
var AddOnePerson = /** @class */ (function (_super) {
    __extends(AddOnePerson, _super);
    function AddOnePerson(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultUserState = function () {
            return {
                firstName: null,
                lastName: null,
                userGroupId: null,
                email: null,
                language: authentication.userLocale(),
                access: UserRole.user,
                external_id: "",
                teams: []
            };
        };
        _this.updateInput = function (label, value) {
            var _a;
            _this.setState((_a = {}, _a[label] = value, _a));
        };
        _this.handleChange = function (label, value) {
            var _a;
            var trimmed = isString(value) ? value.trim() : value;
            _this.setState((_a = {}, _a[label] = trimmed, _a));
        };
        _this.peopleUploaded = function () {
            _this.setState(__assign({ saved: true }, _this.defaultUserState()));
            setTimeout(function () { return _this.setState({ saved: false }); }, 2000);
        };
        _this.createUser = function () {
            _this.setState({
                form: {
                    isLoading: true
                }
            }, function () {
                var _a = _this.state, email = _a.email, firstName = _a.firstName, lastName = _a.lastName, teams = _a.teams, userGroupId = _a.userGroupId, language = _a.language, external_id = _a.external_id, access = _a.access;
                var user = {
                    businessId: authentication.userTenant().uuid,
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    external_id: external_id,
                    language: language || authentication.userLocale()
                };
                var submit = usersService.create({ user: user }).then(function (createdUser) { return __awaiter(_this, void 0, void 0, function () {
                    var teamPromises;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(access === UserRole.admin)) return [3 /*break*/, 2];
                                return [4 /*yield*/, usersService.makeUserGlobalAdmin(createdUser.uuid)];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!userGroupId) return [3 /*break*/, 4];
                                return [4 /*yield*/, teamService.addUserToTeam(userGroupId, createdUser.uuid)];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (!(teams.length > 0)) return [3 /*break*/, 6];
                                teamPromises = teams.map(function (_a) {
                                    var value = _a.value;
                                    return teamService.addUserToTeam(value, createdUser.uuid);
                                });
                                return [4 /*yield*/, Promise.all(teamPromises)];
                            case 5:
                                _a.sent();
                                _a.label = 6;
                            case 6:
                                this.peopleUploaded();
                                adminTracking.createUser("user", teams.map(function (_a) {
                                    var label = _a.label;
                                    return label;
                                }));
                                return [2 /*return*/];
                        }
                    });
                }); });
                _this.setState({ submit: submit });
            });
        };
        _this.handleMFARetry = function () {
            _this.setState({ mfaLoad: mfaService.hasFlag() });
        };
        _this.state = __assign(__assign({}, _this.defaultUserState()), { form: {
                isLoading: false
            }, allTeams: [], submit: null, load: hangPromise(), hasMultiOffices: false, saved: false, mfaLoad: mfaService.hasFlag() });
        return _this;
    }
    AddOnePerson.prototype.componentDidMount = function () {
        var _this = this;
        var load = hasMultipleOffices().then(function (has) {
            _this.setState({ hasMultiOffices: has });
            return teamService.list(authentication.userTenant().uuid).then(function (allTeams) {
                _this.setState({ allTeams: allTeams });
            });
        });
        this.setState({ load: load });
    };
    AddOnePerson.prototype.render = function () {
        var _this = this;
        var _a = this.props, formatMessage = _a.formatMessage, goBack = _a.goBack;
        var _b = this.state, lastName = _b.lastName, email = _b.email, userGroupId = _b.userGroupId, teams = _b.teams, language = _b.language, external_id = _b.external_id, access = _b.access, submit = _b.submit, load = _b.load, hasMultiOffices = _b.hasMultiOffices, allTeams = _b.allTeams, saved = _b.saved, mfaLoad = _b.mfaLoad;
        var firstName = this.state.firstName || "";
        return (React.createElement(Loading, { load: mfaLoad, Error: function () { return React.createElement(YouNeedToMfa, { onRetry: _this.handleMFARetry }); } },
            React.createElement("div", { className: "addOnePerson" },
                React.createElement(Loading, { load: load },
                    goBack && React.createElement(IconButton, { onClick: goBack, icon: "backArrow" }),
                    !saved ? (React.createElement(React.Fragment, null,
                        React.createElement(H2, { marginBottom: 4 },
                            React.createElement(FormattedMessage, { id: "admin.containers.addOnePerson.heading" })),
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 8 },
                                React.createElement(Form, null,
                                    React.createElement(Row, null,
                                        React.createElement(Col, { md: 5 },
                                            React.createElement(Firstname, { value: firstName, onChange: function (value) { return _this.handleChange("firstName", value); } })),
                                        React.createElement(Col, { md: 7 },
                                            React.createElement(Lastname, { value: lastName, onChange: function (value) { return _this.handleChange("lastName", value); } }))),
                                    React.createElement(Locale, { value: language, onChange: function (value) { return _this.handleChange("language", value); } }),
                                    React.createElement(Email, { value: email, onChange: function (value) { return _this.handleChange("email", value); } }),
                                    hasMultiOffices && (React.createElement(Office, { value: userGroupId, onChange: function (value) { return _this.handleChange("userGroupId", value); }, hint: React.createElement(FormattedMessage, { id: "platform.fields.office.hint" }) })),
                                    React.createElement(ExternalID, { value: external_id, hint: React.createElement(FormattedMessage, { id: "admin.containers.addOnePerson.fields.externalId.hint" }), onChange: function (value) { return _this.handleChange("external_id", value); } }),
                                    React.createElement(Select, { label: formatMessage({ id: "admin.containers.addOnePerson.fields.role.label.header" }), options: RoleOptions(formatMessage), value: access, onChange: function (value) { return _this.updateInput("access", value); } }),
                                    allTeams && allTeams.length > 0 && (React.createElement(Select, { isMulti: true, isCreatable: true, label: formatMessage({ id: "admin.containers.addOnePerson.form.fields.label" }), placeholder: formatMessage({ id: "admin.containers.addOnePerson.reactSelect.placeholder" }), name: "team", id: "select_team", value: teams, onChange: function (value) { return _this.updateInput("teams", value); }, options: allTeams.map(function (team) { return ({ value: team.uuid, label: team.public_name }); }) })),
                                    React.createElement("div", null,
                                        React.createElement(Loading, { load: submit, useLoader: false })),
                                    React.createElement(ValidationButton, { primary: true, large: true, full: true, onClick: this.createUser, load: submit },
                                        React.createElement(FormattedMessage, { id: "admin.containers.addOnePerson.validationButton.text", values: { firstName: firstName } }))))))) : (React.createElement(SuccessWithBackLink, { message: formatMessage({ id: "admin.components.savedPopUp.headerTwo" }), onClick: function () { return _this.setState({ saved: false }); } }))))));
    };
    return AddOnePerson;
}(Component));
export default injectIntl(AddOnePerson);
